import { Button, UIHeading4 } from '@cian/ui-kit';
import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './style.css';

export interface INewbuildingShowPhoneProps {
  revealedPhone: string | null;
  isLoading: boolean;
  onClick(): void;
}

export const NewbuildingShowPhone: React.FC<INewbuildingShowPhoneProps> = ({ revealedPhone, isLoading, onClick }) => {
  if (revealedPhone) {
    return (
      <div className={styles['phone']}>
        <UIHeading4 data-testid="Phone" textAlign="center">
          {revealedPhone}
        </UIHeading4>
      </div>
    );
  }

  return (
    <div className={styles['container']}>
      <Button
        size="XS"
        fullWidth
        loading={isLoading}
        beforeIcon={<IconCommunicationPhone16 color="icon-inverted-default" />}
        onClick={onClick}
        data-name="NewbuildingShowPhoneButton"
        data-testid="NewbuildingShowPhoneButton"
      >
        Показать телефон
      </Button>
    </div>
  );
};
